export enum TipoUsuario {
  PROSPECTO = 'PROSPECTO',
  USUARIO = 'USUARIO',
}
